/**
 * Small inline badge indicating debug/sandbox mode.
 * Rendered next to the location name via the locationBadge prop.
 */

export function DebugBadge() {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '1px 6px',
        fontSize: '10px',
        fontWeight: 700,
        letterSpacing: '0.05em',
        lineHeight: '16px',
        borderRadius: '4px',
        backgroundColor: '#F59E0B',
        color: '#78350F',
        whiteSpace: 'nowrap',
        flexShrink: 0,
      }}
    >
      DEBUG
    </span>
  )
}
